<div [formGroup]="form">
    <div class="row mt-2">
        <div class="col-sm-2 bolded">
            {{ "CampCareDayEdit.Club" | translate }}
        </div>
        <div class="col-sm-10 col-md-6">
            <!-- <bcu-drop-down-multiselect [isDisabled]="isBusy" [options]="clubDropdownItems" [shortenWhenAllSelected]="false" [selectAllOption]="false"
      (changed)="onClubsChanged($event)">
    </bcu-drop-down-multiselect> -->
            <select
                formControlName="clubCode"
                class="form-control"
                [attr.disabled]="!canEditClub() ? 'disabled' : null"
            >
                @for (c of clubDropdownItems; track c) {
                    <option [ngValue]="c.value">{{ c.displayName }}</option>
                }
            </select>
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-sm-2 bolded">
            {{ "CampCareDayEdit.Age" | translate }}
        </div>

        <div class="col-sm-4 col-md-3">
            <app-age-picker
                formControlName="ageInMonthsFrom"
                [maxAge]="240"
            ></app-age-picker>
        </div>
        <div class="col-sm-4 col-md-3">
            <app-age-picker
                formControlName="ageInMonthsTo"
                [maxAge]="240"
            ></app-age-picker>
        </div>
        <div class="col-sm-1">
            <i
                class="fa fa-info-circle"
                placement="right"
                aria-hidden="true"
                [tooltip]="ageRangeTooltip"
            >
            </i>
            <ng-template #ageRangeTooltip
                >{{ "CampDetails.AgeRangeExplanation" | translate }}
            </ng-template>
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-sm-2 bolded">
            {{ "CampCareDayEdit.AgeEffective" | translate }}
        </div>

        @if (!ageChange) {
            <div class="col-sm-6 col-md-3">
                <span>
                    {{ form.controls.ageInMonthsFromEffective.value }} -
                    {{ form.controls.ageInMonthsToEffective.value }} months
                </span>
                <button
                    class="btn btn-primary btn-action ml-3"
                    type="button"
                    (click)="toggleAgeChange()"
                >
                    Override
                </button>
            </div>
        }
        @if (ageChange) {
            <div class="col-sm-5 col-md-3">
                <input
                    type="number"
                    class="form-control"
                    formControlName="ageInMonthsFromEffective"
                    min="0"
                    step="1"
                    max="252"
                    numbersOnly="252"
                />
            </div>
        }
        @if (ageChange) {
            <div class="col-sm-5 col-md-3">
                <input
                    type="number"
                    class="form-control"
                    formControlName="ageInMonthsToEffective"
                    min="0"
                    step="1"
                    max="252"
                    numbersOnly="252"
                />
            </div>
        }
    </div>
    <div class="row mt-2">
        <div class="col-sm-2 bolded">
            {{ "CampCareDayEdit.Capacity" | translate }}
        </div>
        <div class="col-sm-5 col-md-1">
            <input
                type="text"
                class="form-control text-center"
                formControlName="capacity"
                [mask]="mask.capacityMask"
            />
        </div>
    </div>

    @if (isGenerateMode()) {
        <div class="row mt-2">
            <div class="col-sm-2 bolded">
                {{ "CampCareDayEdit.Date" | translate }}
            </div>
            <div class="col-sm-5 col-md-3">
                <bcui-date-picker-input2
                    class="date-picker"
                    formControlName="dateFrom"
                    name="dateFrom"
                >
                </bcui-date-picker-input2>
            </div>
            <div class="col-sm-5 col-md-3">
                <bcui-date-picker-input2
                    class="date-picker"
                    formControlName="dateTo"
                    name="dateTo"
                >
                </bcui-date-picker-input2>
            </div>
        </div>
    }

    @if (!isGenerateMode()) {
        <div class="row mt-2">
            <div class="col-sm-2 bolded">
                {{ "CampCareDayEdit.Date" | translate }}
            </div>
            <div class="col-sm-5 col-md-3">
                <bcui-date-picker-input2
                    class="date-picker"
                    formControlName="date"
                    name="date"
                    [dateSelectReadonly]="!canEditDate()"
                >
                </bcui-date-picker-input2>
            </div>
        </div>
    }

    @if (form.controls["slots"]) {
        <div class="mt-2">
            <app-camp-care-slots-edit
                [slots]="form.controls['slots'].value"
            ></app-camp-care-slots-edit>
        </div>
    }
</div>
